 <app-base-doughnut-chart
[chartId]="chartId"
[title]="title"
[labels]="labels"
[data]="data"
[colors]="colors"
type="pie">
</app-base-doughnut-chart>
